class BESSAppProjectProfilerFieldChoiceData {
    constructor(data) {
        this.key = data['key'];
        this.value = data['value'];
        this.dependencyQuestionValue = data['dependency_question_value'];
    }
}